var map = {
	"./chpanamericano-phr/theme.js": [
		66679,
		"chpanamericano-phr-theme-js"
	],
	"./chsf-phr/theme.js": [
		91027,
		"chsf-phr-theme-js"
	],
	"./cliniweb/theme.js": [
		39557,
		"cliniweb-theme-js"
	],
	"./cmcaribe-phr/theme.js": [
		61455,
		"cmcaribe-phr-theme-js"
	],
	"./cmpaitilla-phr/theme.js": [
		79272,
		"cmpaitilla-phr-theme-js"
	],
	"./hchiriqui-phr/theme.js": [
		91371,
		"hchiriqui-phr-theme-js"
	],
	"./hospital-nacional-phr/theme.js": [
		59825,
		"hospital-nacional-phr-theme-js"
	],
	"./hospital-paitilla/theme.js": [
		82873,
		"hospital-paitilla-theme-js"
	],
	"./hsantafe-phr/theme.js": [
		17592,
		"hsantafe-phr-theme-js"
	],
	"./mapfre-guatemala/theme.js": [
		14673,
		"mapfre-guatemala-theme-js"
	],
	"./mapfre-panama-asistencia/theme.js": [
		80422,
		"mapfre-panama-asistencia-theme-js"
	],
	"./mapfre-panama/theme.js": [
		58381,
		"mapfre-panama-theme-js"
	],
	"./pacifica-salud-phr/theme.js": [
		12029,
		"pacifica-salud-phr-theme-js"
	],
	"./sura/theme.js": [
		27783,
		"sura-theme-js"
	],
	"./thepanamaclinic-phr/theme.js": [
		15247,
		"thepanamaclinic-phr-theme-js"
	],
	"./town-center/theme.js": [
		23530,
		"town-center-theme-js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 75813;
module.exports = webpackAsyncContext;